module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "bk-title2"
  }, [_vm._v("OTHER BOOKS IN"), _c('br'), _vm._v(" THE AMERICAN ANTIQUARIAN SOCIETY"), _c('br'), _vm._v(" COOKBOOK COLLECTION")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("American Cookery")]), _vm._v(", by Amelia Simmons")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("The Canadian Housewife’s Manual of Cookery")])]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("The Compleat Housewife")]), _vm._v(", by Eliza Smith")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("The Cook Not Mad")])]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("Cottage Economy, ")]), _vm._v("by William Cobbett")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("Dainty Dishes")]), _vm._v(", by Lady Harriet E. St. Clair")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("Dairying Exemplified")]), _vm._v(", by Josiah Twamley")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("Fifteen Cent Dinners for Families of Six")]), _vm._v(", by Juliet Corson")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("The Hand-Book of Carving")])]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("How to Mix Drinks")]), _vm._v(" by Jerry Thomas")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("Jewish Cookery Book")]), _vm._v(", by Esther Levy")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("Miss Leslie’s New Cookery Book")]), _vm._v(", by Eliza Leslie")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("Mrs. Owen’s Illinois Cook Book")]), _vm._v(", by Mrs. T.J.V. Owen")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("Mrs. Porter’s New Southern Cookery Book")]), _vm._v(", by Mrs. M.E. Porter")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("The New England Cook Book ")])]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("The Times’ Recipes")]), _vm._v(", by "), _c('em', [_vm._v("The New York Times")])]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("A Treatise on Bread")]), _vm._v(", by Sylvester Graham")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("Vegetable Diet")]), _vm._v(", by William Alcott")]), _vm._v(" "), _c('p', {
    staticClass: "center6"
  }, [_c('em', [_vm._v("What to Do with the Cold Mutton")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05233222","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/other.vue
// module id = 60
// module chunks = 0